import { Smile } from "lucide-react";
import {
  MoodCheckParamsSchema,
  defaultMoodCheckParams,
  type MoodCheckParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { MoodCheckWidget } from "./Component.js";
import type { MoodCheckView } from "./types.js";

/**
 * Mood Check — Personal dashboard widget (Personal, medium). A private daily
 * mood check-in. Filed under **Personal** (own input, not AI-generated content)
 * — matching the oracle, not PB-179's "AI widgets" batching. Params stay `{}`
 * (mood never rides the instance — plan §14); `TView` is the controlled
 * `MoodCheckView` resolved from the `personal-state/mood-today@1` dataset, and
 * `onChange` carries the log/update command to the host. The canvas-only
 * `SqlWidgetDef` fields are neutral filler — dashboard-only
 * (`modes: ["dashboard"]`).
 */
export const moodCheckDef: SqlWidgetDef<MoodCheckParams, MoodCheckView> = {
  kind: "moodCheck",
  label: "Mood Check",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 352, h: 160 },
  defaultParams: defaultMoodCheckParams,
  Component: MoodCheckWidget,
  storage: "sql",
  schema: MoodCheckParamsSchema,
  accent: "purple",
  icon: Smile,
  subtitle: "Private daily mood check-in",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 352, height: 160 },
  dashboard: {
    icon: Smile,
    defaultWidth: "medium",
    category: "Personal",
  },
};

registerWidget(moodCheckDef);
